module.exports = __webpack_public_path__ + "media/images/bg-7055c41ebd8df810f775d50d80d72192.png";